import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import CoursePage from './pages/CoursePage';
import SemesterPage from './pages/SemesterPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/planning" element={<CoursePage />} />
          <Route path="/semester" element={<SemesterPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
